import secureLocalStorage from "react-secure-storage";

export const AUTH_TOKEN_KEY = "authToken";
export const PERSIST_ROOT_KEY = "persist:root";

/**
 * One-time cleanup: remove plain-text localStorage keys so old
 * editable values cannot be mixed with encrypted storage.
 */
export function clearLegacyPlainStorage() {
  try {
    if (typeof window === "undefined" || !window.localStorage) {
      return;
    }
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
    window.localStorage.removeItem(PERSIST_ROOT_KEY);
  } catch (e) {
    // ignore
  }
}

clearLegacyPlainStorage();

export function secureGetItem(key) {
  try {
    const value = secureLocalStorage.getItem(key);
    if (value === undefined || value === null) {
      return null;
    }
    return value;
  } catch (e) {
    return null;
  }
}

export function secureSetItem(key, value) {
  try {
    secureLocalStorage.setItem(key, value);
  } catch (e) {
    console.error("Unable to set secure storage item", key, e);
  }
}

export function secureRemoveItem(key) {
  try {
    secureLocalStorage.removeItem(key);
  } catch (e) {
    console.error("Unable to remove secure storage item", key, e);
  }
}

/**
 * redux-persist compatible storage (Promise-based API).
 * Values are encrypted via react-secure-storage.
 */
export const securePersistStorage = {
  getItem: function (key) {
    return Promise.resolve(secureGetItem(key));
  },
  setItem: function (key, value) {
    secureSetItem(key, value);
    return Promise.resolve();
  },
  removeItem: function (key) {
    secureRemoveItem(key);
    return Promise.resolve();
  },
};
